import { cn } from "@/lib/utils";
import { Text } from "components/core/Text";
import { SectionTitle } from "components/core/typography/SectionTitle";
import { ClassAttributes, ComponentProps, HTMLAttributes } from "react";

const Section = ({
    children,
    className,
    ...props
}: ClassAttributes<HTMLElement> & HTMLAttributes<HTMLElement>) => {
    return (
        <section className={cn("flex flex-col", className)} {...props}>
            {children}
        </section>
    );
};

const Header = ({
    children,
    className,
    ...props
}: ClassAttributes<HTMLElement> & HTMLAttributes<HTMLElement>) => {
    return (
        <header
            className={cn("mb-3 flex justify-between md:mb-6", className)}
            {...props}
        >
            {children}
        </header>
    );
};

const Column = ({
    children,
    className,
    ...props
}: ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement>) => {
    return (
        <div className={cn("flex flex-col gap-1", className)} {...props}>
            {children}
        </div>
    );
};

const Desc = ({
    children,
    ...props
}: Omit<ComponentProps<typeof Text>, "variant" | "color">) => {
    return (
        <Text variant="body3" color="text.disabled" tag="p" {...props}>
            {children}
        </Text>
    );
};

const Controls = ({
    children,
    className,
    ...props
}: ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement>) => {
    return (
        <div className={cn("flex items-center", className)} {...props}>
            {children}
        </div>
    );
};

const Contents = ({
    children,
    ...props
}: ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement>) => {
    return <div {...props}>{children}</div>;
};

export const SectionScaffold = Object.assign(Section, {
    Header,
    Column,
    Title: SectionTitle,
    Desc,
    Controls,
    Contents
});
